function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { Colors as BaseColors, ThemingContext } from '@doordash/design-language';
import { PaginationContainer, PaginationIndicator, PaginationIndicators, Root } from './styles';
import PaginationSelectedIndicator from './PaginationSelectedIndicator';
import PropTypes from 'prop-types';
import React from 'react';
import { Sizes } from './constants';

var Pagination = function Pagination(_ref) {
  var count = _ref.count,
      selectedIndex = _ref.selectedIndex,
      onSelect = _ref.onSelect,
      color = _ref.color,
      size = _ref.size,
      accessibilityLabel = _ref.accessibilityLabel,
      indicatorAccessibilityLabelPrefix = _ref.indicatorAccessibilityLabelPrefix;
  var theme = React.useContext(ThemingContext);
  var borderRadius = theme.BorderRadius.PaginationDefault;
  var colorOptions = {
    Red: {
      selected: BaseColors.SystemRed60,
      unselected: BaseColors.SystemGrey10
    },
    White: {
      selected: BaseColors.SystemWhite,
      unselected: BaseColors.SystemGrey50
    },
    Grey: {
      selected: BaseColors.SystemGrey60,
      unselected: BaseColors.SystemGrey10
    },
    Primary: {
      selected: theme.Colors.PaginationSelectedPrimary,
      unselected: theme.Colors.PaginationUnselectedPrimary
    },
    Dark: {
      selected: theme.Colors.PaginationSelectedDark,
      unselected: theme.Colors.PaginationUnselectedDark
    },
    Light: {
      selected: theme.Colors.PaginationSelectedLight,
      unselected: theme.Colors.PaginationUnselectedLight
    }
  };
  return React.createElement(Root, null, React.createElement(PaginationContainer, null, React.createElement(PaginationIndicators, {
    size: size.spacing,
    "aria-label": accessibilityLabel
  }, _toConsumableArray(Array(count).keys()).map(function (index) {
    return React.createElement(PaginationIndicator, {
      key: index,
      onClick: function onClick(event) {
        return onSelect(index, event);
      },
      isSelected: index === selectedIndex,
      "aria-current": index === selectedIndex,
      size: size,
      borderRadius: borderRadius,
      color: colorOptions[color],
      "aria-label": "".concat(indicatorAccessibilityLabelPrefix, " ").concat(index + 1)
    });
  })), React.createElement(PaginationSelectedIndicator, {
    size: size,
    selectedIndex: selectedIndex,
    borderRadius: borderRadius,
    color: colorOptions[color]
  })));
};

Pagination.Colors = {
  Red: 'Red',
  White: 'White',
  Grey: 'Grey',
  Primary: 'Primary',
  Dark: 'Dark',
  Light: 'Light'
};
Pagination.Sizes = Sizes;
Pagination.propTypes = {
  /**
   * `onSelect` is called with the value of the new
   * selectedIndex.
   */
  onSelect: PropTypes.func.isRequired,

  /**
   * `selectedIndex` can be an integer or a float.
   * If it's a float, then the selected indicator
   * will live inbetween whole pagination indicators.
   *
   * This is useful for creating continuous animations
   * (like swipes/scrolls) with the Pagination component.
   */
  selectedIndex: PropTypes.number.isRequired,

  /**
   * Count is the number of indicators that should be visible.
   */
  count: PropTypes.number.isRequired,
  color: PropTypes.oneOf(Object.values(Pagination.Colors)).isRequired,
  size: PropTypes.oneOf(Object.values(Pagination.Sizes)).isRequired,
  accessibilityLabel: PropTypes.string.isRequired,
  indicatorAccessibilityLabelPrefix: PropTypes.string.isRequired
};
Pagination.defaultProps = {
  // eslint-disable-next-line no-console,no-unused-vars
  onSelect: function onSelect(selectedIndex) {},
  selectedIndex: 0,
  count: 3,
  color: Pagination.Colors.Red,
  size: Pagination.Sizes.Medium
};
export default Pagination;